import React from 'react';
import auth0 from 'auth0-js';
import { AUTH_CONFIG } from './auth0-variables';

import moment from 'moment';
// import { EventEmitter } from 'events';

import Users from '../users/Users';

class Auth extends React.Component {

	constructor() {
		super();

	  this.auth0 = new auth0.WebAuth({
	    domain: AUTH_CONFIG.domain,
	    audience: `https://${AUTH_CONFIG.domain}/userinfo`,
	    clientID: AUTH_CONFIG.clientId,
	    redirectUri: AUTH_CONFIG.callbackUrl,
	    responseType: 'token id_token',
	    scope: 'openid profile'
	  });

		this.login = this.login.bind(this);
		this.logout = this.logout.bind(this);
		this.handleAuthentication = this.handleAuthentication.bind(this);
		this.isAuthenticated = this.isAuthenticated.bind(this);

    this.getProfile = this.getProfile.bind(this);
    this.setSession = this.setSession.bind(this);
	}

  handleAuthentication() {
  	console.log('auth0: handleAuthentication');
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        //console.log('auth0: parseHash');
        //console.log(err);
        //console.log(authResult);
        if (err) return reject(err);
        if (!authResult || !authResult.idToken) {
					console.log('handleAuthentication ERROR');
          return reject(err);
        }
				console.log('handleAuthentication SUCCESS');
        this.setSession(authResult, function() {
	        resolve();
        });
      });
    })
  }

	setSession(authResult, callback) {
		var _this = this;
		// console.log('setSession');
		// console.log(authResult);

		// Set the time that the access token will expire at
		// console.log('authResult.expiresIn');
		// console.log(authResult.expiresIn);

		let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());

		localStorage.setItem('access_token', authResult.accessToken);
		localStorage.setItem('id_token', authResult.idToken);
		localStorage.setItem('expires_at', expiresAt);
		// navigate to the home route

		this.auth0.client.userInfo(authResult.accessToken, function(err, profile) {
			//console.log('setSession: profile');
			//console.log(profile);

			if(err) {
				console.log('Auth setSession: Error loading profile');
				callback();
			} else {

				profile.user_id = profile.sub;
				_this.setProfile(profile);

				// Write/update new connection info to DB
				var UserData = {};
				UserData.user_id = profile.user_id;
				UserData.auth0_name = profile.name;
				UserData.picture = profile.picture;

				Users.setNewConnection(UserData, function() {
					callback();
				});
			}
    });
	}

	login() {
		this.auth0.authorize();
	}

	logout() {
		// Clear access token and ID token from local storage
		localStorage.removeItem('access_token');
		localStorage.removeItem('id_token');
		localStorage.removeItem('expires_at');
	}

	isAuthenticated() {
		// Check whether the current time is past the 
		// access token's expiry time
		let expiresAt = JSON.parse(localStorage.getItem('expires_at'));

		console.log('isAuthenticated ? expiresAt');
		console.log(moment(new Date()).toISOString(true));
		console.log(moment(expiresAt).toISOString(true));

		return new Date().getTime() < expiresAt;
	}

	getProfile() {
		// Retrieves the profile data from localStorage
		const profile = localStorage.getItem('profile');
		return profile ? JSON.parse(localStorage.profile) : {};
	}

	setProfile(profile) {

		// console.log('Auth: setProfile');

		// Saves profile data to localStorage
		localStorage.setItem('profile', JSON.stringify(profile));

		// Triggers profile_updated event to update the UI
		// this.emit('profile_updated', profile);
	}

	getAccessToken() {
		const accessToken = localStorage.getItem('access_token');
		return accessToken;
	}
}

export default Auth;
